import { useState } from "react";
import { Navigation } from "@/components/home/Navigation";
import { Hero } from "@/components/home/Hero";
import { Features } from "@/components/home/Features";
import { About } from "@/components/home/About";
import { PricingSection } from "@/components/home/PricingSection";
import { FAQ } from "@/components/home/FAQ";
import { Footer } from "@/components/home/Footer";
import { SEO } from "@/components/shared/SEO";

const Home = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="Home"
        description="Track your child's developmental journey with Bright Stages - the comprehensive platform for monitoring progress and celebrating achievements."
      />
      <Navigation scrollToSection={scrollToSection} />
      <Hero />
      
      {/* Features Section */}
      <section id="features" className="features-section py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-semibold text-center mb-16 font-heading">
            Comprehensive Development Tracking
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mx-auto max-w-6xl place-items-center">
            <Features />
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20">
        <div className="container mx-auto px-6 md:px-8">
          <About />
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-semibold text-center mb-16 font-heading">
            Pricing
          </h2>
          <PricingSection />
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-20">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-semibold text-center mb-16 font-heading">
            Frequently Asked Questions
          </h2>
          <FAQ />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;
